import React from "react";
import useStepPersistence from "../../Hooks/useStepPersistience";
import PersonalInformationStep from "../../organisms/PersonalInformationStep";
const PersonalInformationContainer = ({ formData, setFormStep, user, errors, loading, setPreviousStep, index, }) => {
    const [data, handleChange, handleSubmit] = useStepPersistence({
        employer_title: "",
        employer_last_name: "",
        employer_email: "",
    }, formData, setFormStep);
    return (React.createElement(PersonalInformationStep, { onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), user: user, errors: errors, loading: loading, setPreviousStep: setPreviousStep, index: index }));
};
export default PersonalInformationContainer;
